export const surfaceWipesFormFields = [
    { name: 'name', type: 'text' as const, placeholder: 'Your Name*', required: true },
    { name: 'company', type: 'text' as const, placeholder: 'Company Name*', required: true },
    { name: 'email', type: 'email' as const, placeholder: 'Company Email*', required: true },
    { name: 'phone', type: 'tel' as const, placeholder: 'Phone*', required: true },
    { 
        name: 'size', 
        type: 'select' as const, 
        placeholder: 'Size',
        options: [
            { value: '72 count or less', label: '72 count or less' },
            { value: '75-144 count', label: '75-144 count' },
            { value: '145+ count', label: '145+ count' }
        ]
    },
    { 
        name: 'quantity', 
        type: 'select' as const, 
        placeholder: 'Quantity',
        options: [
            { value: '1-50', label: '1-50' },
            { value: '51-100', label: '51-100' },
            { value: '101-500', label: '101-500' },
            { value: '501+', label: '501+' }
        ]
    }
]; 